import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { API_URL } from '../../../common/constants/api-url';
import { CouponDto } from '../../reducers/coupons/getCouponListReducer';
import { getBaseQuery } from '../base-query';
import {
  AttachProductsReqBody,
  CreateCouponReqBody,
  DetachProductReqBody,
  GetCouponListReqBody,
} from './coupons-api-types';

export const couponsApiSlice = createApi({
  baseQuery: getBaseQuery({
    baseUrl: `${API_URL}/admin/product-coupons`,
  }),
  endpoints: (builder) => ({
    attachProducts: builder.mutation<null, AttachProductsReqBody>({
      invalidatesTags: [{
        id: 'LIST',
        type: 'ProductCoupons',
      }],
      query: (body) => ({
        body,
        method: 'POST',
        url: '/attach',
      }),
    }),
    createCoupon: builder.mutation<null, CreateCouponReqBody>({
      query: (body) => ({
        body,
        method: 'POST',
        responseHandler: 'text',
        url: '',
      }),
    }),
    detachProducts: builder.mutation<null, DetachProductReqBody>({
      invalidatesTags: [{
        id: 'LIST',
        type: 'ProductCoupons',
      }],
      query: (body) => ({
        body,
        method: 'POST',
        url: '/detach',
      }),
    }),
    getCouponList: builder.query<CouponDto[], GetCouponListReqBody>({
      providesTags: (result) => {
        if (Array.isArray(result)) {
          return [
            ...result.map(({ id }) => ({
              id,
              type: 'ProductCoupons',
            }) as const),
            {
              id: 'LIST',
              type: 'ProductCoupons',
            },
          ];
        }
        return [{
          id: 'LIST',
          type: 'ProductCoupons',
        }];
      },

      query: (params) => ({
        method: 'GET',
        params,
        url: '',
      }),
    }),
    updateCoupon: builder.mutation<null, Partial<CreateCouponReqBody>>({
      invalidatesTags: [{
        id: 'LIST',
        type: 'ProductCoupons',
      }],
      query: (body) => ({
        body,
        method: 'PUT',
        url: '',
      }),
    }),
  }),
  reducerPath: 'couponsApi',
  tagTypes: ['ProductCoupons'],
});
